/**
 * Optional entry templates (D5 of PRODUCT_PLAN).
 *
 * The catalog lives in code (versioned); visible text is translated
 * in the UI layer with Lingui from `key` — only structure lives here.
 * The entry stores `template_key` for future statistics.
 */

export interface JournalTemplate {
  key: string;
  /** Guidance lines inserted into the body when the template is selected. */
  promptKeys: string[];
}

export const ENTRY_TEMPLATES: readonly JournalTemplate[] = [
  {
    key: "gratitude",
    promptKeys: ["gratitude.intro", "gratitude.first", "gratitude.second", "gratitude.third"],
  },
  {
    key: "three_good_things",
    promptKeys: ["three_good_things.first", "three_good_things.second", "three_good_things.third"],
  },
] as const;

export function getTemplateByKey(key: string | null | undefined): JournalTemplate | undefined {
  if (!key) return undefined;
  return ENTRY_TEMPLATES.find((t) => t.key === key);
}
